/** Data local YYYY-MM-DD (sem fuso) para comparar com plannedDate. */
export function todayIsoDateLocal(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isPlannedDateInPast(plannedDate: string, reference = todayIsoDateLocal()): boolean {
  const p = plannedDate.slice(0, 10);
  const r = reference.slice(0, 10);
  return p < r;
}

export function formatPlannedDateBr(isoDate: string): string {
  const [y, m, d] = isoDate.slice(0, 10).split('-');
  if (!y || !m || !d) return isoDate;
  return `${d}/${m}/${y}`;
}
